// Packages
import { Component, createRef } from "react";
// import axios from 'axios';
import { withRouter } from "react-router-dom";
import { FormGroup } from "reactstrap";

// Views
import SchoolAdminDashboard from "../schoolAdminDashboard";

// Styles
import "../schoolAdmin.css";

// Material Ui
import Container from "@material-ui/core/Container";
import { getFromLocalStorage } from "../../../utils/webStorage";
import CamelCaseString from "../../../Common/CamelCaseString";
import blankProfile from "../images/blank-profile.png";

//Utils
import { Form, Formik } from "formik";
import validationSchema from "../../../Validation/ValidationSchemas";
import PageNotFoundPage from "../../../Common/PageNotFoundPage";
import { connect } from "react-redux";
import {
  openConfirmationPopup,
  openFailDialog,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";
import {
  createGroup,
  getActiveAthletesList,
  getActiveCoachesList,
  getActiveTeamAdminsList,
  handleGroupLogoUpload,
  resetGroupData,
  searchActiveAthletes,
  searchActiveCoaches,
  searchActiveTeamAdmins,
  setGroupSearchQuery,
  setGroupSearchedRecord,
  setSelectedAthletesList,
  setSelectedCoachesList,
  setSelectedTeamAdminsList,
} from "../../../Redux/Actions/GroupActions";
import FormikTextField from "../../../Common/FormFields/FormikInputField";
import CustomMultiSelectDropdown from "../../../Common/FormFields/CustomMultiSelectDropdown";
import { ContentLayoutSpinner } from "../../spinner/ContentLayoutSpinner";
import ContentLayoutHeader from "../../../Common/ContentLayoutHeader";
import ImageUploadContainer from "../../../Common/FormFields/ImageUploadContainer";

class AddSchoolCoaches extends Component {
  constructor(props) {
    super(props);
    this.schoolId = getFromLocalStorage("schoolId");
    this.currentUserId = getFromLocalStorage("currentUserId");
    this.athleteScrollRef = createRef();
    this.coachesScrollRef = createRef();
    this.teamAdminScrollRef = createRef();
  }

  componentDidMount() {
    const { schoolId } = this;
    const {
      getActiveCoachesList,
      getActiveAthletesList,
      pageState,
      coachesPageState,
      getActiveTeamAdminsList,
      teamAdminPageState,
    } = this.props;
    getActiveCoachesList({
      schoolId,
      page: coachesPageState.page,
      size: coachesPageState.pageSize,
      status: false,
    });
    getActiveAthletesList({
      schoolId,
      page: pageState.page,
      size: pageState.pageSize,
      status: false,
    });
    getActiveTeamAdminsList({
      schoolId,
      page: teamAdminPageState.page,
      size: teamAdminPageState.pageSize,
      status: false,
    });
  }

  componentWillUnmount() {
    const { resetGroupData } = this.props;
    resetGroupData({ status: false });
  }

  handleAthlete = (value, isAdded) => {
    const { selectedAthletesList, setSelectedAthletesList } = this.props;
    setSelectedAthletesList({
      selectedList: isAdded
        ? [...selectedAthletesList, value]
        : selectedAthletesList.filter((el) => el.id !== value.id),
    });
  };

  handleCoach = (value, isAdded) => {
    const { selectedCoachesList, setSelectedCoachesList } = this.props;
    setSelectedCoachesList({
      selectedList: isAdded
        ? [...selectedCoachesList, value]
        : selectedCoachesList.filter((el) => el.id !== value.id),
    });
  };

  handleTeamAdmin = (value, isAdded) => {
    const { selectedTeamAdminsList, setSelectedTeamAdminsList } = this.props;
    setSelectedTeamAdminsList({
      selectedList: isAdded
        ? [...selectedTeamAdminsList, value]
        : selectedTeamAdminsList.filter((el) => el.id !== value.id),
    });
  };

  handleSubmit({ groupName }) {
    const {
      createGroup,
      selectedAthletesList,
      selectedCoachesList,
      selectedTeamAdminsList,
      groupLogoId,
    } = this.props;
    const { schoolId } = this;
    createGroup({
      groupName: CamelCaseString(groupName),
      coaches: selectedCoachesList.map((item) => item.id),
      athletes: selectedAthletesList.map((item) => item.id),
      teamAdmins: selectedTeamAdminsList.map((item) => item.id),
      schoolId,
      uploadId: groupLogoId,
    });
  }

  handleCancel = () => {
    const { setConfirmationPopupInformation } = this.props;
    setConfirmationPopupInformation({
      confirmationPopup: {
        open: true,
        message: `Are You Sure You Want To Cancel?`,
        btnColor: "red",
        btnText: `Yes`,
        type: "Add Group",
        cancelLink: "/groups",
      },
    });
  };

  onScoll = (pageState, pageStateName, ref) => {
    const { schoolId } = this;
    const {
      getActiveCoachesList,
      getActiveAthletesList,
      getActiveTeamAdminsList,
      searchActiveCoaches,
      searchActiveAthletes,
      searchActiveTeamAdmins,
      loading,
    } = this.props;

    if (pageState.page < pageState.totalPages && !loading.scrollLoading) {
      if (ref.current) {
        const { scrollTop, scrollHeight, clientHeight } = ref.current;
        if (Math.round(scrollTop + clientHeight + 1) >= scrollHeight) {
          switch (pageStateName) {
            case "coachesPageState":
              pageState.searchedRecord
                ? searchActiveCoaches({
                    searchQuery: pageState.searchQuery,
                    schoolId,
                    page: pageState.page,
                    size: pageState.pageSize,
                  })
                : getActiveCoachesList({
                    schoolId,
                    page: pageState.page,
                    size: pageState.pageSize,
                    status: true,
                  });
              break;

            case "pageState":
              pageState.searchedRecord
                ? searchActiveAthletes({
                    searchQuery: pageState.searchQuery,
                    schoolId,
                    page: pageState.page,
                    size: pageState.pageSize,
                  })
                : getActiveAthletesList({
                    schoolId,
                    page: pageState.page,
                    size: pageState.pageSize,
                    status: true,
                  });
              break;

            case "teamAdminPageState":
              pageState.searchedRecord
                ? searchActiveTeamAdmins({
                    searchQuery: pageState.searchQuery,
                    schoolId,
                    page: pageState.page,
                    size: pageState.pageSize,
                  })
                : getActiveTeamAdminsList({
                    schoolId,
                    page: pageState.page,
                    size: pageState.pageSize,
                    status: true,
                  });
              break;

            default:
              break;
          }
        }
      }
    }
  };

  setSearchQueryOrSearchedRecord = (value, pageStateName, isSearchQuery) => {
    const { setGroupSearchQuery, setSearchedRecord } = this.props;
    if (isSearchQuery) {
      setGroupSearchQuery({
        pageStateName: pageStateName,
        searchQuery: value,
      });
    } else {
      setSearchedRecord({
        pageStateName: pageStateName,
        status: value,
      });
    }
  };

  checkSelectedTeamAdmins = () => {
    const { activeTeamAdminsList, selectedTeamAdminsList } = this.props;
    const filteredTeamAdminList = activeTeamAdminsList?.map((ol) => {
      const isDisabled = selectedTeamAdminsList.filter((el) => el.id === ol.id);
      return isDisabled.length > 0
        ? { ...ol, disabled: true }
        : { ...ol, disabled: false };
    });

    return filteredTeamAdminList;
  };

  checkSelectedAtheletes = () => {
    const { activeAthletesList, selectedAthletesList } = this.props;
    const filteredAthletesList = activeAthletesList?.map((ol) => {
      const isDisabled = selectedAthletesList?.filter((el) => el.id === ol.id);
      return isDisabled.length > 0
        ? { ...ol, disabled: true }
        : { ...ol, disabled: false };
    });

    return filteredAthletesList;
  };

  checkSelectedCoaches = () => {
    const { activeCoachesList, selectedCoachesList } = this.props;
    const filteredCoachesList = activeCoachesList?.map((ol) => {
      const isDisabled = selectedCoachesList?.filter((el) => el.id === ol.id);
      return isDisabled.length > 0
        ? { ...ol, disabled: true }
        : { ...ol, disabled: false };
    });

    return filteredCoachesList;
  };

  handleLogoUpload = (file) => {
    const { handleGroupLogoUpload } = this.props;
    const { currentUserId } = this;
    handleGroupLogoUpload({
      file: file,
      currentUserId: currentUserId,
    });
  };

  render(props) {
    const {
      currentSeason,
      loading,
      selectedTeamAdminsList,
      groupLogo,
      selectedAthletesList,
      selectedCoachesList,
      coachesPageState,
      pageState,
      teamAdminPageState,
      searchActiveCoaches,
      getActiveCoachesList,
      getActiveAthletesList,
      getActiveTeamAdminsList,
      searchActiveTeamAdmins,
      searchActiveAthletes,
      isDrawerOpen,
    } = this.props;
    return (
      <>
        {currentSeason ? (
          <Formik
            initialValues={{
              groupName: "",
            }}
            validationSchema={validationSchema.groupSchema}
            onSubmit={(values) => this.handleSubmit(values)}
          >
            {(formik) => (
              <Form>
                <div
                  // className="content-layout add-sectionn p-0 position-relative"
                  className={
                    isDrawerOpen
                      ? "content-layout add-sectionn p-0 position-relative"
                      : "toggle-content-layout add-sectionn p-0 position-relative"
                  }
                >
                  <SchoolAdminDashboard />
                  <ContentLayoutSpinner animate={loading?.pageLoading} />
                  <ContentLayoutHeader
                    heading="Add Group"
                    handleCancel={this.handleCancel}
                    navigationLink={`/groups`}
                    btnText="Add"
                    loading={loading?.buttonLoading}
                    disabled={!formik.isValid}
                  />
                  <Container className="mg-top-70 mg-bottom-20">
                    <form name="adminRegistrationForm">
                      <div className="col-lg-5 col-12 col-sm-12">
                        <div className="moboMargin-5">
                          <div className="white-card">
                            <ImageUploadContainer
                              id="upload-photo-1"
                              logoUrl={groupLogo ? groupLogo : blankProfile}
                              handleUpload={(file) =>
                                this.handleLogoUpload(file)
                              }
                              label={
                                groupLogo
                                  ? "Update Group Logo"
                                  : "Add Group Logo"
                              }
                              loading={loading?.profileImageLoading}
                            />
                          </div>
                          <div className="clear20"></div>
                          <div className="white-card">
                            <div className="row fs-18 ">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="row">
                                  <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <FormikTextField
                                      label="Group Name"
                                      formik={formik}
                                      fieldName="groupName"
                                      placeholder="Enter Group Name"
                                      labelFontSize="fs-18"
                                    />
                                    <FormGroup className="fs-14">
                                      <label className="fmlabel mt-6 semi-bold fs-18">
                                        Coaches{" "}
                                        <span className="redstar"></span>
                                      </label>
                                      <CustomMultiSelectDropdown
                                        defaultSelectOption="Select Coaches"
                                        selected={selectedCoachesList}
                                        setSelected={this.handleCoach}
                                        options={this.checkSelectedCoaches()}
                                        fieldToShow="fullName"
                                        isDisabled="disabled"
                                        searchQuery={
                                          coachesPageState?.searchQuery
                                        }
                                        setSearchQuery={(value) => {
                                          this.setSearchQueryOrSearchedRecord(
                                            value,
                                            "coachesPageState",
                                            true
                                          );
                                        }}
                                        searchedRecord={
                                          coachesPageState?.searchedRecord
                                        }
                                        setSearchedRecord={(value) => {
                                          this.setSearchQueryOrSearchedRecord(
                                            value,
                                            "coachesPageState",
                                            false
                                          );
                                        }}
                                        getDataByPage={(page) => {
                                          getActiveCoachesList({
                                            schoolId: this.schoolId,
                                            page: page,
                                            size: 10,
                                            status: false,
                                          });
                                        }}
                                        searchData={(value, page, size) => {
                                          searchActiveCoaches({
                                            searchQuery: value,
                                            schoolId: this.schoolId,
                                            page: page,
                                            size: size,
                                            status: false,
                                          });
                                        }}
                                        onScroll={() =>
                                          this.onScoll(
                                            coachesPageState,
                                            "coachesPageState",
                                            this.coachesScrollRef
                                          )
                                        }
                                        ref={this.coachesScrollRef}
                                      />
                                    </FormGroup>
                                    <FormGroup className="fs-14">
                                      <label className="fmlabel mt-6 semi-bold fs-18">
                                        Athletes{" "}
                                        <span className="redstar"></span>
                                      </label>
                                      <CustomMultiSelectDropdown
                                        defaultSelectOption="Select Athletes"
                                        selected={selectedAthletesList}
                                        setSelected={this.handleAthlete}
                                        options={this.checkSelectedAtheletes()}
                                        fieldToShow="fullName"
                                        isDisabled="disabled"
                                        searchQuery={pageState?.searchQuery}
                                        setSearchQuery={(value) =>
                                          this.setSearchQueryOrSearchedRecord(
                                            value,
                                            "pageState",
                                            true
                                          )
                                        }
                                        searchedRecord={
                                          pageState?.searchedRecord
                                        }
                                        setSearchedRecord={(value) =>
                                          this.setSearchQueryOrSearchedRecord(
                                            value,
                                            "pageState",
                                            false
                                          )
                                        }
                                        getDataByPage={(page) => {
                                          getActiveAthletesList({
                                            schoolId: this.schoolId,
                                            page: page,
                                            size: 10,
                                            status: false,
                                          });
                                        }}
                                        searchData={(value, page, size) => {
                                          searchActiveAthletes({
                                            searchQuery: value,
                                            schoolId: this.schoolId,
                                            page: page,
                                            size: size,
                                            status: false,
                                          });
                                        }}
                                        onScroll={() =>
                                          this.onScoll(
                                            pageState,
                                            "pageState",
                                            this.athleteScrollRef
                                          )
                                        }
                                        ref={this.athleteScrollRef}
                                      />
                                    </FormGroup>
                                    <FormGroup className="fs-14">
                                      <label className="fmlabel mt-6 semi-bold fs-18">
                                        Team Admins{" "}
                                        <span className="redstar"></span>
                                      </label>
                                      <CustomMultiSelectDropdown
                                        defaultSelectOption="Select Team Admins"
                                        selected={selectedTeamAdminsList}
                                        setSelected={this.handleTeamAdmin}
                                        options={this.checkSelectedTeamAdmins()}
                                        fieldToShow="fullName"
                                        isDisabled="disabled"
                                        searchQuery={
                                          teamAdminPageState?.searchQuery
                                        }
                                        setSearchQuery={(value) =>
                                          this.setSearchQueryOrSearchedRecord(
                                            value,
                                            "teamAdminPageState",
                                            true
                                          )
                                        }
                                        searchedRecord={
                                          teamAdminPageState?.searchedRecord
                                        }
                                        setSearchedRecord={(value) => {
                                          this.setSearchQueryOrSearchedRecord(
                                            value,
                                            "teamAdminPageState",
                                            false
                                          );
                                        }}
                                        getDataByPage={(page) => {
                                          getActiveTeamAdminsList({
                                            schoolId: this.schoolId,
                                            page: page,
                                            size: 10,
                                            status: false,
                                          });
                                        }}
                                        searchData={(value, page, size) => {
                                          searchActiveTeamAdmins({
                                            searchQuery: value,
                                            schoolId: this.schoolId,
                                            page: page,
                                            size: size,
                                            status: false,
                                          });
                                        }}
                                        onScroll={() =>
                                          this.onScoll(
                                            teamAdminPageState,
                                            "teamAdminPageState",
                                            this.teamAdminScrollRef
                                          )
                                        }
                                        ref={this.teamAdminScrollRef}
                                      />
                                    </FormGroup>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </Container>
                </div>
              </Form>
            )}
          </Formik>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setConfirmationPopupInformation: (obj) =>
      openConfirmationPopup(dispatch, obj),
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
    createGroup: (obj) => createGroup(dispatch, obj),
    getActiveCoachesList: (obj) => getActiveCoachesList(dispatch, obj),
    getActiveAthletesList: (obj) => getActiveAthletesList(dispatch, obj),
    setSelectedCoachesList: (obj) => setSelectedCoachesList(dispatch, obj),
    setSelectedAthletesList: (obj) => setSelectedAthletesList(dispatch, obj),
    handleGroupLogoUpload: (obj) => handleGroupLogoUpload(dispatch, obj),
    resetGroupData: (obj) => resetGroupData(dispatch, obj),
    getActiveTeamAdminsList: (obj) => getActiveTeamAdminsList(dispatch, obj),
    setSelectedTeamAdminsList: (obj) =>
      setSelectedTeamAdminsList(dispatch, obj),
    setGroupSearchQuery: (obj) => setGroupSearchQuery(dispatch, obj),
    searchActiveCoaches: (obj) => searchActiveCoaches(dispatch, obj),
    searchActiveAthletes: (obj) => searchActiveAthletes(dispatch, obj),
    searchActiveTeamAdmins: (obj) => searchActiveTeamAdmins(dispatch, obj),
    setSearchedRecord: (obj) => setGroupSearchedRecord(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    currentSeason: state?.loggedInUser?.userProfile?.currentSeason,
    activeCoachesList: state?.GroupsData?.activeCoachesList,
    activeAthletesList: state?.GroupsData?.activeAthletesList,
    activeTeamAdminsList: state?.GroupsData?.activeTeamAdminsList,
    selectedCoachesList: state?.GroupsData?.selectedCoachesList,
    selectedAthletesList: state?.GroupsData?.selectedAthletesList,
    loading: state?.GroupsData?.loading,
    groupLogo: state?.GroupsData?.groupLogo,
    groupLogoId: state?.GroupsData?.groupLogoId,
    pageState: state?.GroupsData?.pageState,
    coachesPageState: state?.GroupsData?.coachesPageState,
    teamAdminPageState: state?.GroupsData?.teamAdminPageState,
    selectedTeamAdminsList: state?.GroupsData?.selectedTeamAdminsList,
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddSchoolCoaches)
);
